import { graphql, useStaticQuery } from "gatsby"
import React, { useEffect, useRef } from "react"
import ReCAPTCHA from "react-google-recaptcha"
import RegisterSuccess from "../../../../shared/components/modals/register-success/register-success"
import Button from "../../../components/atoms/button/button"
import GenericModal from "../../../components/modals/generic-modal/generic-modal"
import * as reCaptchaKey from "../../../constants/reCaptcha"
import AuthService from "../../../services/auth-service"
import RegisterService from "../../../services/register-service"
import { siteUrl } from "../../../utils/siteUrl"
import LogoMini from "../../../assets/images/logo/logo-mini.svg"
import "./step-code-verification.scss"

const StepCodeVerification = props => {
  const result = useStaticQuery(
    graphql`
      query ModalInfo {
        contentfulNolRegistro {
          descripcionModalCodigoVerificacion
        }
        contentfulNolHome {
          logoNosotras {
            file {
              url
            }
            description
          }
        }
      }
    `
  )

  var mainLogo = result.contentfulNolHome.logoNosotras

  var homeLink = siteUrl + "/"

  const [response, setResponse] = React.useState("waiting")
  const [resentCode, setResentCode] = React.useState(false)
  const [inputValue, setInputValue] = React.useState(
    props.fromUrl ? props.infoUser.code : ""
  )
  var mail = props.email
    ? props.email
    : typeof window !== "undefined"
    ? props.fromUrl
      ? props.infoUser.email
      : JSON.parse(sessionStorage.getItem("userData")).email
    : "example@example.com"
  const recaptchaRef = useRef(null)

  const handleInputValidation = e => {
    var payload = {
      code: e.target.value,
      username: mail,
    }

    if (e.target.value.length === 6) {
      RegisterService.codeVerificationRegister(payload)
        .then(res => {
          if (res.data) {
            setResponse("success")
          } else {
            setResponse("error")
          }

          return
        })
        .catch(err => {
          console.error(err)
        })
    } else {
      setResponse("waiting")
    }
  }

  const fromUrlValidation = () => {
    var payload = {
      code: props.infoUser.code,
      username: mail,
    }

    if (props.infoUser.code.length === 6) {
      RegisterService.codeVerificationRegister(payload)
        .then(res => {
          if (res.data) {
            setResponse("success")
            props.setSuccessRegisterModal(<RegisterSuccess />)
          } else {
            setResponse("error")
          }

          return
        })
        .catch(err => {
          console.error(err)
        })
    }
  }

  const resendCodeTarget = () => {
    setResentCode(true)

    setTimeout(() => {
      setResentCode(false)
    }, 10000)
    var payload = {
      username: mail,
    }

    RegisterService.codeVerificationResend(payload).then(res => {
      console.log(res)
    })
  }

  const login = () => {
    var tempInfo = JSON.parse(sessionStorage.getItem("userData"))

    var payload = {
      email: tempInfo.email,
      password: tempInfo.password,
      captcha: recaptchaRef.current.getValue(),
    }

    AuthService.authentication(payload)
      .then(res => {
        //Validate errors
        if (res.status === 400 || res.status === 404) {
          console.log(res)
        } else if (res.status === 200) {
          localStorage.setItem(
            "TOKEN_INFO",
            JSON.stringify({
              accessToken: res.data.token.accessToken,
              expiresIn: res.data.token.expiresIn,
              idToken: res.data.token.idToken,
              tokenType: res.data.token.tokenType,
              refreshToken: res.data.token.refreshToken,
              email: res.data.email,
            })
          )
        }
      })
      .catch(err => console.log(err))
  }

  const showSuccessModal = () => {
    if (response === "success") {
      login()
      props.setSuccessRegisterModal(<RegisterSuccess urlActivity={props.urlActivity} />)
    }
  }

  useEffect(() => {
    recaptchaRef.current.execute()
    if (props.fromUrl) {
      fromUrlValidation()
    }
  }, [])

  return (
    <GenericModal>
      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        sitekey={reCaptchaKey.key}
      />
      <div className="f-main-title-container">
        <label className="f-main-title">Bienvenida</label>
      </div>
      <div className="f-sub-title-container-generic">
        <label className="f-sub-title">AL MUNDO DE</label>
      </div>
      <img className="f-img-into-text" src={LogoMini} alt=";ogo-nosotras" />
      <div className="f-description-container">
        <p className="f-description">
          {result.contentfulNolRegistro.descripcionModalCodigoVerificacion}
        </p>
      </div>
      <div className="f-input-container">
        <label className="f-input-indicator">CÓDIGO VERIFICACIÓN</label>
        <div className="f-input-validation-container">
          <input
            name="f-verification-code-input"
            placeholder="Ingresa el código"
            className={
              "f-verification-code-input " +
              (response === "success" && " f-success-validation ") +
              (response === "error" && " f-error-validation")
            }
            type="text"
            maxLength="6"
            autoComplete="off"
            value={inputValue}
            onChange={e => {
              handleInputValidation(e)
              setInputValue(e.target.value)
            }}
          />
          {response === "error" && inputValue.length === 6 ? (
            <span className="icon2-close f-icon f-error-code"></span>
          ) : null}
          {response === "success" && inputValue.length === 6 ? (
            <span className="icon-check-2 f-icon f-check-code"></span>
          ) : null}
        </div>
        {response === "error" && inputValue.length === 6 ? (
          <label className="f-code-error">Código inválido</label>
        ) : null}
        {!resentCode && (
          <label className="f-send-code">
            ¿No recibiste un código?{" "}
            <span className="f-link-send-code" onClick={resendCodeTarget}>
              Reenviar código
            </span>
          </label>
        )}
        {resentCode && (
          <p className="f-send-code-re">Tu código ha sido enviado</p>
        )}
      </div>
      <div className="f-modal-separator"></div>
      <div className="f-btn-container">
        <div className="f-btn-interaction-container" onClick={showSuccessModal}>
          <Button title="Terminar mi registro" className=" new-primary-pink" />
        </div>
      </div>
      <a href={homeLink}>
        <span className="icon2-close f-icon f-close-icon"></span>
      </a>
    </GenericModal>
  )
}

export default StepCodeVerification
